import React, { useEffect, useState } from "react";
import { CoinList } from "./config/api";
import { CryptoState } from "./CryptoContext";
import axios from "axios";
import {
  Container,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  ThemeProvider,
  Typography,
  createTheme,
  makeStyles,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { numberWithCommas } from "./components/Carousel";
import { Pagination } from "@material-ui/lab";

const useStyles = makeStyles(() => ({
    row:{
        backgroundColor:"#000080",
        cursor:"pointer",
        "&:hover":{
            backgroundColor:"#2525A4"
        },
        fontFamily:"Montserrat",
        transition:"0.3s"
    },
    pagination:{
        "& MuiPaginationItem-root":{
            color:"#e64072"
        }
    }
}));

function Coinstable() {
  const [search, setSearch] = useState("");

  const [page,setPage] = useState(1);

  const classes = useStyles();

  const { currency, symbol,coins,loading ,fetchCoins} = CryptoState();

  

  useEffect(() => {
    fetchCoins();
  }, [currency]);

  const darkTheme = createTheme({
    palette: {
      primary: {
        main: "#fff",
      },
      type: "dark",
    },
  });

  const handleSearch = () => {
    return coins.filter((coin) => 
      coin.name.toLowerCase().includes(search) ||
        coin.symbol.toLowerCase().includes(search)
    );
  };

  const navigate = useNavigate();

  return (
    <ThemeProvider theme={darkTheme}>
      <Container style={{ textAlign: "center" }}>
        <Typography
          variant="h4"
          style={{ margin: 18, fontFamily: "Montserrat" }}
        >
          Cryptocurrency Prices By Market Cap
        </Typography>
        <TextField
          label="Search for a Crypto Currency.."
          variant="outlined"
          style={{
            marginBottom: 20,
            width: "100%",
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
        <TableContainer>
          {loading ? (
            <LinearProgress style={{ backgroundColor: "white" }} />
          ) : (
            <Table>
              <TableHead style={{ backgroundColor: "#e64072" }}>
                <TableRow>
                  {["Coin", "Price", "24h Change", "Market Cap"].map((head) => (
                    <TableCell
                      style={{
                        color: "white",
                        fontWeight: "700",
                        fontFamily: "Montserrat",
                      }}
                      key={head}
                      align={head === "Coin" ? "" : "right"}
                    >
                      {head}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {handleSearch()
                    .slice((page-1)*10,(page-1)*10 +10)
                .map((row) => {
                  const profit = row.price_change_percentage_24h > 0;

                  return (
                    <TableRow
                      onClick={() => {
                        navigate(`/coins/${row.id}`);
                      }}
                      className={classes.row}
                      key={row.name}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        style={{ display: "flex", gap: 15 ,}}
                      >
                        <img
                          src={row?.image}
                          alt={row.name}
                          height="50"
                          style={{ marginBottom: 10 }}
                        />
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <span
                            style={{
                              textTransform: "uppercase",
                              fontSize: 22,
                            }}
                          >
                            {row.symbol}
                          </span>
                          <span style={{ color: "darkgrey" }}>{row.name}</span>
                        </div>
                      </TableCell>

                      <TableCell align="right">
                        {symbol}{" "}
                        {numberWithCommas(row.current_price.toFixed(2))}
                      </TableCell>

                      <TableCell align="right" style={{
                        color:profit > 0 ?"rgba(14,203,129)" : "red",
                        fontWeight:500
                      }}>
                        {profit && "+"}
                        {row.price_change_percentage_24h.toFixed(2)}%
                      </TableCell>
                        
                      <TableCell align="right">
                      {symbol}{" "}
                        {numberWithCommas(row.market_cap.toString().slice(0,-6))}
                        M
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          )}
        </TableContainer>
        <Pagination 
            style={{
                padding:20,
                width:"100%",
                display:"flex",
                justifyContent:"center"
            }}
            className={classes.pagination}
            count = {(handleSearch()?.length/10).toFixed(0)}
            onChange={(_,value)=>{
                setPage(value);
                window.scroll(0,450);
            }}
        />
      </Container>
    </ThemeProvider>
  );
}

export default Coinstable;
